module.exports = {"dashboard":"System dashborad"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/homepage.json
// module id = 35M3
// module chunks = 58